export class Queue {
	static queue: QueueItem[] = [];
	static pendingPromise = false;
	static stop = false;
	static workingOnPromise = false;

	static enqueue(promise: () => Promise<any>) {
		return new Promise((resolve, reject) => {
			this.queue.push({
				promise,
				resolve,
				reject
			});
			this.dequeue();
		});
	}

	static dequeue() {
		if (this.workingOnPromise) {
			return false;
		}
		if (this.stop) {
			this.queue = [];
			this.stop = false;
			return;
		}
		const item = this.queue.shift();
		if (!item) {
			return false;
		}
		try {
			this.workingOnPromise = true;
			item.promise()
				.then(value => {
					this.workingOnPromise = false;
					item.resolve(value);
					this.dequeue();
				})
				.catch(err => {
					this.workingOnPromise = false;
					item.reject(err);
					this.dequeue();
				});
		} catch (err) {
			this.workingOnPromise = false;
			item.reject(err);
			this.dequeue();
		}
		return true;
	}
}

interface QueueItem {
	promise: () => Promise<any>;
	resolve: (value: any) => void;
	reject: (reason: any) => void;
}
